import { render, staticRenderFns } from "./CoderSettings.vue?vue&type=template&id=0a9dd4ba&scoped=true"
import script from "./CoderSettings.vue?vue&type=script&lang=js"
export * from "./CoderSettings.vue?vue&type=script&lang=js"
import style0 from "./CoderSettings.vue?vue&type=style&index=0&id=0a9dd4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9dd4ba",
  null
  
)

export default component.exports